import { render, staticRenderFns } from "./edit-dropdown.vue?vue&type=template&id=5389b85e&"
import script from "./edit-dropdown.vue?vue&type=script&lang=js&"
export * from "./edit-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports